import { useEffect, useLayoutEffect, useState } from 'react'
import { breakpoints } from '../constants/breakpoint.constants'

export function useWindowSize() {
  const [size, setSize] = useState({ width: 0, height: 0 })
  const [mode, setMode] = useState<'desktop' | 'mobile' | 'tablet' | ''>('')

  useLayoutEffect(() => {
    function updateSize() {
      setSize({ width: window.innerWidth, height: window.innerHeight })
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    if (size.width <= breakpoints.md) {
      setMode('mobile')
    } else if (breakpoints.md < size.width && size.width <= breakpoints.lg) {
      setMode('tablet')
    } else {
      setMode('desktop')
    }
  }, [size.width, size.height])

  // useEffect(() => {
  //   console.log('MODE: ', { mode, size: size.width })
  // }, [mode, size.width])

  return { size, mode }
}
